import {OrganizationApiConfig} from 'types/organizations/organizationApiConfig';
import {visionApi} from 'apis/cemitApis/trainApi/visionApiImplementation.ts';

const routes = visionApi?.routes;
export const visionApiConfig: OrganizationApiConfig = {
  api: visionApi,
  routes,
};
